import { fetchSingleChallenge } from '@actions/challenges';
import { fetchSubmissionsForChallenge } from '@actions/submissions';
import { RootState } from '@reducers/index';
import { getChallenge } from '@selectors/challenges';
import {
    getSubmissions,
    getSubmissionsFetchError,
    getSubmissionsIsFetching,
} from '@selectors/submissions';
import { useEffect } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { fetchCompleteSubmissionsForChallenge } from '@actions/submissions/fetchCompleteSubmissionsForChallenge';

const useFetchSubmissions = (challengeID: number, shouldFetchComplete = false) => {
    const dispatch = useDispatch();

    useEffect(() => {
        batch(() => {
            if (shouldFetchComplete) {
                dispatch(fetchCompleteSubmissionsForChallenge(challengeID));
            } else {
                dispatch(fetchSubmissionsForChallenge(challengeID));
            }
            dispatch(fetchSingleChallenge(challengeID));
        });
    }, [dispatch, challengeID, shouldFetchComplete]);

    const submissions = Object.values(useSelector(getSubmissions));
    const isFetching = useSelector(getSubmissionsIsFetching);
    const fetchError = useSelector(getSubmissionsFetchError);
    const challenge = useSelector((state: RootState) => getChallenge(state, challengeID));

    return { challenge, submissions, isFetching, fetchError };
};

export default useFetchSubmissions;
